<form [formGroup]="form" (ngSubmit)="save()">
    <h1 mat-dialog-title>Seleccionar profesionales</h1>
    <div mat-dialog-content>
        <mat-spinner *ngIf="loading"></mat-spinner>
        <mat-form-field *ngIf="!loading" class="full-width">
            <mat-select placeholder="Profesionales" formControlName="physicians" multiple>
                <mat-select-trigger>
                    {{f.physicians.value?.length > 0 ? f.physicians.value[0].Name : ''}}
                    <span *ngIf="f.physicians.value?.length > 1" class="additional-selection">
                        (+{{f.physicians.value.length - 1}} {{f.physicians.value?.length === 2 ? 'otra' : 'otros'}})
                      </span>
                </mat-select-trigger>
                <mat-option *ngFor="let physicianFilter of physicianFilters" [value]="physicianFilter">
                    {{physicianFilter.Name}}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="f.physicians.errors && f.physicians.errors.required">
                Seleccione algún profesional
            </mat-error>
        </mat-form-field>
    </div>
    <div class="clearfix">
        <div *ngIf="!loading" class="pull-right">
            <button mat-button type="submit">Guardar</button>
            <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Cancelar</button>
        </div>
    </div>
</form>